module.exports = __webpack_public_path__ + "static/media/olimpia-sp.718cf70d.jpg";